import React, { useState } from "react"
import { useTranslation } from "next-i18next"

import StaticBundle from "@/components/Bundles/StaticBundle"

import { getTranslations } from "@/components/Bundles/localization"

import Style from "@/components/Bundles/StaticBundle/BundlesViewDetails/index.module.scss"
import { viewDetailsBundleAnalytics } from "@/components/Bundles/analytics"

const BundlesViewDetails = props => {
  const {
    lineItem = [],
    bundleItemsCount = 0,
    productInfoData = {},
    page = {},
  } = props

  const { t } = useTranslation("common")
  const { includedItemsQty = () => {}, viewDetails = "" } = getTranslations(t)

  const [viewBundle, setViewBundle] = useState("")

  const viewBundleDetails = () => {
    setViewBundle(!viewBundle)
    const collapseTitle = !viewBundle ? "expand" : "collapse"
    const productInfo =
      productInfoData?.length > 0 ? JSON.parse(productInfoData) : null
    viewDetailsBundleAnalytics(collapseTitle, productInfo)
  }

  const staticBundleData = { lineItem }

  return (
    <div className={Style.PreviewCartBundleSection}>
      <p className="preview-bundle-included">
        {includedItemsQty(bundleItemsCount)}
      </p>
      <p
        className={`view-bundle-details ${viewBundle ? "bundle-open" : ""}`}
        onClick={viewBundleDetails}
      >
        {viewDetails}
      </p>
      {viewBundle ? (
        <StaticBundle data={staticBundleData} isViewBundle page={page} />
      ) : null}
    </div>
  )
}

export default BundlesViewDetails
